import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ProgressBar from "../components/ProgressBar";
import UserRegistrationForm from "../components/UserRegistrationForm";
import { sendTestResultsEmail } from "../services/emailService";
import { calculateBelbin } from "../services/testCalculations";

const belbinQuestions = [
  {
    id: 1,
    title: "Какой вклад я могу внести в работу команды:",
    options: {
      a: "Я думаю, что смогу быстро замечать и использовать новые возможности",
      b: "Я могу хорошо работать с самыми разными людьми",
      c: "Генерирование идей - мое естественное достоинство",
      d: "Моя способность привлекать людей проявляется тогда, когда я чувствую, что встреча служит важной цели",
      e: "У меня есть склонность доводить дело до конца, что получается у меня весьма эффективно",
      f: "Я готов перенести временную непопулярность, если это приведет к стоящим результатам в конце",
      g: "Обычно я чувствую, что является реалистичным и выполнимым",
      h: "Я могу предложить нечто альтернативное без предрассудков или предубеждений"
    }
  },
  {
    id: 2,
    title: "Если у меня есть недостатки в командной работе, то возможно это потому, что:",
    options: {
      a: "Я не спокоен до тех пор, пока встречи не станут хорошо структурированными, контролируемыми и в общем продуктивными",
      b: "Я склонен быть великодушным к тем, кто имеет обоснованную точку зрения, которая не была должным образом рассмотрена",
      c: "У меня есть тенденция много говорить, как только группа обсуждает новые идеи",
      d: "Мой объективный взгляд мешает мне присоединиться к коллегам в их энтузиазме",
      e: "Иногда меня видят как человека силы и авторитарности, если нужно сделать что-то",
      f: "Мне трудно взять на себя лидерство, поскольку я слишком чувствителен к атмосфере группы",
      g: "Я склонен увлекаться идеями, которые приходят мне в голову, и поэтому теряю след того, что происходит",
      h: "Мои коллеги считают, что я слишком беспокоюсь о деталях и возможности того, что что-то может пойти неправильно"
    }
  },
  {
    id: 3,
    title: "Когда я вовлечен в работу с другими:",
    options: {
      a: "У меня есть влияние на людей, не подавляя их",
      b: "Моя настороженность предотвращает совершение ошибок и погрешностей, которые возникают из-за небрежности",
      c: "Я готов настаивать на каком-то курсе действий без предрассудков или колебаний",
      d: "Можно рассчитывать на то, что я внесу что-то оригинальное",
      e: "Я всегда готов поддержать хорошее предложение в общих интересах",
      f: "Я стремлюсь искать последние новинки, идеи и разработки",
      g: "Я думаю, что мое способность выносить суждения может помочь в принятии правильных решений",
      h: "На меня можно положиться в плане того, что работа будет выполнена"
    }
  },
  {
    id: 4,
    title: "Мой характерный подход к групповой работе состоит в том, что:",
    options: {
      a: "У меня есть особый интерес в хорошем знании коллег, их талантов и качеств",
      b: "Я не колеблюсь оспорить точки зрения других или поддержать меньшинство мнений",
      c: "Обычно я могу найти линию аргумента, чтобы опровергнуть несостоятельные предложения",
      d: "Я думаю, у меня есть талант заставить что-то работать, как только план должен быть реализован",
      e: "У меня есть тенденция избегать очевидного и выдвигать что-то неожиданное",
      f: "Я привношу чувство профессионализма в любую работу, которую я предпринимаю",
      g: "Я готов использовать контакты за пределами группы",
      h: "Хотя я серьезно интересуюсь всеми точками зрения, у меня нет проблем с принятием решения, когда это необходимо"
    }
  },
  {
    id: 5,
    title: "Я получаю удовлетворение от работы, потому что:",
    options: {
      a: "Мне нравится анализировать ситуации и взвешивать все возможные варианты выбора",
      b: "Мне интересно находить практические решения проблем",
      c: "Мне нравится чувствовать, что я способствую хорошим рабочим отношениям",
      d: "Я могу оказать сильное влияние на решения",
      e: "Я могу встретиться с людьми, которые могут предложить что-то новое",
      f: "Я могу заставить людей согласиться по поводу необходимого курса действий",
      g: "Я чувствую себя в своей стихии, когда могу уделить задаче свое полное внимание",
      h: "Мне нравится находить область, которая расширяет мое воображение"
    }
  },
  {
    id: 6,
    title: "Если мне внезапно дают трудное задание с ограниченным временем и незнакомыми людьми:",
    options: {
      a: "Я буду чувствовать себя загнанным в угол до тех пор, пока не выберусь из тупика и не найду путь вперед",
      b: "Я буду работать с тем, кто показывает наиболее позитивный подход, каким бы трудным ни было задание",
      c: "Я найду способ уменьшить размер задачи, установив, какой вклад могут внести разные люди",
      d: "Мое естественное чувство срочности поможет обеспечить соблюдение сроков",
      e: "Я думаю, что буду сохранять хладнокровие и способность мыслить ясно",
      f: "Я буду держаться за цель, несмотря на давление",
      g: "Я буду готов взять на себя лидерство, если чувствую, что группа не добивается прогресса",
      h: "Я бы инициировал дискуссии с целью стимулировать новые идеи и сдвинуть дело с мертвой точки"
    }
  },
  {
    id: 7,
    title: "Что касается проблем, с которыми я сталкиваюсь, работая в группах:",
    options: {
      a: "Я склонен выражать нетерпение по отношению к тем, кто препятствует прогрессу",
      b: "Другие могут критиковать меня за то, что я слишком аналитичен и недостаточно интуитивен",
      c: "Мое желание убедиться в том, что работа выполнена должным образом, может замедлить дело",
      d: "Я склонен легко терять интерес, когда первоначальная привлекательность исчезла",
      e: "Мне трудно начинать, если цели не ясны",
      f: "Иногда мне трудно объяснить и разъяснить сложные вопросы, которые приходят мне в голову",
      g: "Я знаю, что требую от других того, что сам не могу дать",
      h: "Я не решаюсь изложить свои взгляды перед лицом сильной оппозиции"
    }
  },
  {
    id: 8,
    title: "При участии в знакомой работе с людьми:",
    options: {
      a: "Я стремлюсь узнать больше от людей с опытом в различных областях",
      b: "Я часто преуспеваю в убеждении группы принять общую точку зрения",
      c: "Я обычно тот, кто видит, когда рабочие усилия нуждаются в реорганизации",
      d: "Я имею репутацию человека, который может справиться с самыми трудными клиентами или посетителями",
      e: "Я могу видеть, как идеи и методы, используемые в одном месте, могут быть адаптированы в другом месте",
      f: "Я легко нахожу общий язык с людьми, при условии, что они искренни в своих целях",
      g: "Я часто нахожу себя ответственным за то, чтобы идеи превратились в планы и системы",
      h: "Я имею склонность к перфекционизму"
    }
  }
];

const BelbinTest = () => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});
  const [userInfo, setUserInfo] = useState({
    full_name: "",
    email: "",
    phone: ""
  });
  const [isStarted, setIsStarted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleStart = () => {
    setIsStarted(true);
  };

  const handleAnswerChange = (option, value) => {
    const questionId = currentQuestion + 1;
    const currentAnswers = answers[questionId] || {};
    
    // Валидация: проверяем, что значение находится в диапазоне 0-10
    const numValue = parseFloat(value);
    if (!isNaN(numValue) && numValue >= 0 && numValue <= 10) {
      const newAnswers = { ...currentAnswers, [option]: numValue };
      setAnswers({
        ...answers,
        [questionId]: newAnswers
      });
    } else if (value === '' || value === '0') {
      // Пустое значение автоматически считается за 0
      const newAnswers = { ...currentAnswers, [option]: 0 };
      setAnswers({
        ...answers,
        [questionId]: newAnswers
      });
    }
  };

  const isValidValue = (value) => {
    const numValue = parseFloat(value);
    return !isNaN(numValue) && numValue >= 0 && numValue <= 10;
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === 'Return') {
      // Проверяем, что все 10 баллов распределены
      const totalPoints = getTotalPoints(currentQuestion + 1);
      if (totalPoints === 10) {
        // Переходим к следующему вопросу или завершаем тест
        if (currentQuestion < belbinQuestions.length - 1) {
          nextQuestion();
        } else {
          submitTest();
        }
      } else {
        // Показываем сообщение, что нужно распределить все баллы
        alert(`Пожалуйста, распределите все 10 баллов. Осталось: ${10 - totalPoints} баллов.`);
      }
    }
  };

  const getTotalPoints = (questionId) => {
    const questionAnswers = answers[questionId] || {};
    return Object.values(questionAnswers).reduce((sum, val) => sum + (val || 0), 0);
  };

  const nextQuestion = () => {
    if (currentQuestion < belbinQuestions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    }
  };

  const prevQuestion = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
    }
  };

  const canProceed = () => {
    const questionId = currentQuestion + 1;
    return getTotalPoints(questionId) === 10;
  };

  const submitTest = async () => {
    setIsSubmitting(true);
    try {
      // Calculate results on frontend
      const testResult = calculateBelbin(answers);
      testResult.userInfo = userInfo;
      testResult.testType = 'belbin';
      testResult.answers = answers; // Добавляем исходные ответы для детального отображения
      
      // Send email with detailed results and Excel attachment
      const emailResult = await sendTestResultsEmail(testResult, 'belbin');
      
      if (emailResult.success) {
        console.log('✅ Email sent successfully');
        if (emailResult.excelCreated) {
          console.log(`📊 Excel file created: ${emailResult.excelFileName}`);
        }
      } else {
        console.error('❌ Email sending failed:', emailResult.error);
      }
      
      // Excel файл для теста Belbin не поддерживается
      console.log('📊 Excel файл для теста Belbin не создается (не поддерживается)');
      
      // Store results for display
      const displayResult = {
        id: Date.now().toString(),
        test_type: 'belbin',
        user_info: userInfo,
        results: {
          allRoles: testResult.allRoles,
          topRoles: testResult.topRoles,
          summary: testResult.summary
        },
        timestamp: new Date().toISOString()
      };
      
      // Store in localStorage for display
      localStorage.setItem('lastTestResult', JSON.stringify(displayResult));
      
      // Navigate to thank you page
      navigate('/thank-you');
      
    } catch (error) {
      console.error("Error submitting test:", error);
      alert("Ошибка при отправке результатов. Попробуйте еще раз.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isStarted) {
    const testDescription = (
      <div className="mb-6 p-4 bg-purple-50 rounded-md">
        <h3 className="font-semibold text-purple-800 mb-2">О тесте:</h3>
        <p className="text-purple-700 text-sm mb-2">
          Тест командных ролей поможет определить вашу предпочтительную роль в команде.
        </p>
        <p className="text-purple-700 text-sm mb-2">
          <strong>Инструкция:</strong> В каждом блоке распределите 10 баллов между 8 утверждениями.
          Можете поставить все 10 баллов одному утверждению или распределить между несколькими.
        </p>
      </div>
    );

    return (
      <UserRegistrationForm
        userInfo={userInfo}
        setUserInfo={setUserInfo}
        onStart={handleStart}
        testTitle="Анкета по Белбину"
        testDescription={testDescription}
        buttonText="Начать тест (8 блоков)"
      />
    );
  }

  const question = belbinQuestions[currentQuestion];
  const isLastQuestion = currentQuestion === belbinQuestions.length - 1;
  const currentQuestionId = currentQuestion + 1;
  const totalPoints = getTotalPoints(currentQuestionId);
  const remainingPoints = 10 - totalPoints;

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white p-8 rounded-lg shadow-md">
          <ProgressBar current={currentQuestion + 1} total={belbinQuestions.length} className="mb-8" />
          
          <div className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Блок {currentQuestion + 1}
            </h2>
            <p className="text-gray-700 text-lg mb-6">
              {question.title}
            </p>
            
            <div className="mb-4 p-3 bg-gray-100 rounded-md">
              <p className="text-sm text-gray-700">
                Распределено баллов: <span className="font-semibold">{totalPoints}</span> из 10
                {remainingPoints > 0 && (
                  <span className="text-orange-600 ml-2">
                    (осталось: {remainingPoints})
                  </span>
                )}
                {remainingPoints === 0 && (
                  <span className="text-green-600 ml-2">✓</span>
                )}
              </p>
            </div>

            <div className="mb-4 p-3 bg-blue-50 rounded-md">
              <p className="text-blue-800 text-sm">
                💡 <strong>Подсказка:</strong> Введите баллы от 0 до 10 для каждого пункта. 
                Нажмите Enter для перехода к следующему блоку (только когда все 10 баллов распределены).
              </p>
            </div>

            <div className="space-y-4">
              {Object.entries(question.options).map(([option, text]) => (
                <div key={option} className="border rounded-md p-4">
                  <p className="text-gray-700 mb-3 text-sm">
                    <strong>{option.toUpperCase()})</strong> {text}
                  </p>
                  <div className="flex items-center space-x-2">
                    <label className="text-sm text-gray-600">Баллы (0-10):</label>
                    <input
                      type="text"
                      value={answers[currentQuestionId]?.[option]?.toString() || ''}
                      onChange={(e) => handleAnswerChange(option, e.target.value)}
                      onKeyPress={handleKeyPress}
                      className={`w-16 p-2 border rounded focus:outline-none focus:ring-2 ${
                        answers[currentQuestionId]?.[option] !== undefined && answers[currentQuestionId]?.[option] !== ''
                          ? (isValidValue(answers[currentQuestionId]?.[option]?.toString() || '')
                              ? 'border-green-500 focus:ring-green-500'
                              : 'border-red-500 focus:ring-red-500')
                          : 'border-gray-300 focus:ring-purple-500'
                      }`}
                      placeholder="0-10"
                    />
                    {answers[currentQuestionId]?.[option] !== undefined && 
                     answers[currentQuestionId]?.[option] !== '' && 
                     !isValidValue(answers[currentQuestionId]?.[option]?.toString() || '') && (
                      <p className="text-red-500 text-xs">Введите значение от 0 до 10</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex justify-between">
            <button
              onClick={prevQuestion}
              disabled={currentQuestion === 0}
              className="px-6 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Назад
            </button>
            
            {isLastQuestion ? (
              <button
                onClick={submitTest}
                disabled={isSubmitting || !canProceed()}
                className="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? "Отправка..." : "Завершить тест"}
              </button>
            ) : (
              <button
                onClick={nextQuestion}
                disabled={!canProceed()}
                className="px-6 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Далее
              </button>
            )}
          </div>
          
          {!canProceed() && (
            <p className="text-red-600 text-sm mt-2 text-center">
              Необходимо распределить ровно 10 баллов для продолжения
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default BelbinTest;
